module.exports = __webpack_public_path__ + "img/n3_2.f2b738de.jpg";